import axios from "axios";
import store from "@/store";
import { getXAuthToken, getXAuthAgent } from "@/utils/auth";

const serviceUpload = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 120000
});

serviceUpload.interceptors.request.use(
  config => {
    if (store.getters.x_auth_token != "") {
      config.headers["X-Auth-Token"] = "Bearer " + store.getters.x_auth_token;
    } else if (getXAuthToken() != "" && getXAuthToken() != null) {
      config.headers["X-Auth-Token"] = "Bearer " + getXAuthToken();
    }
    if (store.getters.x_auth_agent != "") {
      config.headers["X-Auth-Agent"] = "Bearer " + store.getters.x_auth_agent;
    } else if (getXAuthAgent() != "" && getXAuthAgent() != null) {
      config.headers["X-Auth-Agent"] = "Bearer " + getXAuthAgent();
    }
    // Jangan set Content-Type; browser menambahkan boundary multipart.
    return config;
  },
  error => Promise.reject(error)
);

serviceUpload.interceptors.response.use(
  response => {
    const body = response.data;
    if (!body || body.status !== 200) {
      return Promise.reject(new Error((body && body.msg) || "Error"));
    }
    return body;
  },
  error => Promise.reject(error)
);

export default serviceUpload;



// WEBPACK FOOTER //
// ./src/utils/requestUpload.js